import {
  FaUser,
  FaUsers,
  FaCogs,
  FaUserTie,
  FaUserCog,
  FaListAlt,
  FaLayerGroup,
  FaUserFriends,
  FaProjectDiagram,
  FaFileExport,
  FaKey,
} from 'react-icons/fa';
import {
  MdAccessTime,
  MdOutlinePortrait,
  MdOutlinePersonPin,
  MdOutlinePersonSearch,
  MdOutlineAssignmentInd,
  MdOutlineAssignmentLate,
  MdOutlineAssignmentTurnedIn,
  MdOutlinePermContactCalendar,
  MdOutlineDangerous,
  MdSettings,
} from 'react-icons/md';
import { VscGroupByRefType } from 'react-icons/vsc';
import { HiOutlineStatusOnline } from 'react-icons/hi';
import { BiGitCompare } from 'react-icons/bi';
import DashboardIcon from '@mui/icons-material/Dashboard';
import config from '@config';

import i18n from '../../../../i18n';

export default (roles = [], permissions = []) => {
  const permissionList = permissions.map((permission) => permission.name);
  const rolesList = roles.map((role) => role.name);
  return [
    {
      title: i18n.t('pages'),
      pages: [
        {
          allowedRoles: ['administrator', 'admin', 'operator'],
          allowedPermissions: ['access_dashboard'],
          title: i18n.t('dashboard'),
          href: '/dashboard',
          icon: DashboardIcon,
        },
        {
          allowedRoles: ['administrator', 'admin'],
          title: 'user management',
          href: '/users',
          icon: FaUserCog,
          children: [
            {
              allowedRoles: ['administrator', 'admin'],
              notAllowedPermissions: ['!manage_users'],
              title: i18n.t('online_operators'),
              href: '/user-management/online-operators',
              icon: FaUsers,
            },
            {
              allowedRoles: ['administrator', 'admin'],
              notAllowedPermissions: ['!manage_users'],
              title: i18n.t('users'),
              href: '/user-management/users',
              icon: FaUser,
            },
            {
              allowedRoles: ['administrator', 'admin'],
              notAllowedPermissions: ['!manage_users'],
              title: i18n.t('endusers'),
              href: '/user-management/endusers',
              icon: FaUserTie,
            },
            {
              allowedRoles: ['administrator'],
              notAllowedPermissions: ['!manage_groups'],
              title: 'user groups',
              href: '/user-management/groups',
              icon: FaUserFriends,
            },
          ],
        },

        {
          allowedRoles: ['administrator', 'admin'],
          title: i18n.t('configuration'),
          href: '/configuration',
          icon: FaCogs,
          children: [
            {
              allowedRoles: ['administrator'],
              title: 'tenants',
              href: '/configuration/tenants',
              icon: FaLayerGroup,
            },
            {
              allowedRoles: ['administrator', 'admin'],
              notAllowedPermissions: ['!manage_workflows'],
              title: 'workflows',
              href: '/configuration/workflows',
              icon: FaProjectDiagram,
            },
            {
              allowedRoles: ['administrator', 'admin'],
              notAllowedPermissions: ['!manage_partitions'],
              title: 'partitions',
              href: '/configuration/partitions',
              icon: VscGroupByRefType,
            },
            {
              allowedRoles: ['administrator'],
              title: 'ssoProfiles',
              href: '/configuration/sso-profiles',
              icon: FaKey,
            },
          ],
        },

        {
          title: i18n.t('session management'),
          href: '/session-management',
          icon: FaListAlt,
          children: [
            {
              allowedRoles: ['administrator', 'admin'],
              title: 'sessions',
              href: '/session-management/sessions',
              icon: MdOutlineAssignmentInd,
            },
            {
              allowedRoles: ['operator'],
              title: 'sessions',
              href: '/session-management/sessions/supervisor',
              icon: MdOutlineAssignmentInd,
            },
            {
              allowedRoles: ['administrator', 'operator', 'partition_agent'],
              title: 'pre_validation',
              href: '/session-management/pre-validation',
              icon: MdOutlinePortrait,
            },
            {
              allowedRoles: ['administrator', 'operator', 'partition_agent'],
              title: 'into-pre-validation',
              href: '/session-management/into-pre-validation',
              icon: MdOutlinePermContactCalendar,
            },
            {
              allowedRoles: ['administrator', 'operator', 'partition_agent'],
              title: 'validation',
              notAllowedPermissions: [
                'pre_approve_session',
                'see_all_sessions',
              ],
              href: '/session-management/validation',
              icon: MdOutlinePersonPin,
              canSkip:
                rolesList.includes('operator') &&
                permissionList.includes('see_all_sessions'),
            },
            {
              allowedRoles: ['operator'],
              title: 'validation',
              href: '/session-management/supervisor/validation',
              allowedPermissions: ['see_all_sessions'],
              icon: MdOutlinePersonPin,
            },

            {
              allowedRoles: ['administrator', 'operator', 'partition_agent'],
              title: 'validation in progress',
              href: '/session-management/validation-in-progress',
              notAllowedPermissions: [
                'pre_approve_session',
                'see_all_sessions',
              ],
              icon: MdOutlinePersonSearch,
              canSkip:
                rolesList.includes('operator') &&
                permissionList.includes('see_all_sessions'),
            },

            {
              allowedRoles: ['operator'],
              title: 'validation in progress',
              href: '/session-management/supervisor/validation-in-progress',
              allowedPermissions: ['see_all_sessions'],
              icon: MdOutlinePersonSearch,
            },
            {
              allowedRoles: ['administrator', 'operator', 'partition_agent'],
              title: 'waiting room',
              href: '/session-management/waiting-room',
              notAllowedPermissions: [
                'pre_approve_session',
                'see_all_sessions',
              ],
              icon: MdAccessTime,
              canSkip:
                rolesList.includes('operator') &&
                permissionList.includes('see_all_sessions'),
            },
            {
              allowedRoles: ['operator'],
              title: 'waiting room',
              href: '/session-management/supervisor/waiting-room',
              allowedPermissions: ['see_all_sessions'],
              icon: MdAccessTime,
            },
            {
              allowedRoles: ['administrator', 'operator', 'partition_agent'],
              title: 'partially_rejected',
              href: '/session-management/partially-rejected',
              notAllowedPermissions: [
                'pre_approve_session',
                'see_all_sessions',
              ],
              icon: MdOutlineAssignmentLate,
              canSkip:
                rolesList.includes('operator') &&
                permissionList.includes('see_all_sessions'),
            },

            {
              allowedRoles: ['operator'],
              title: 'partially_rejected',
              href: '/session-management/supervisor/partially-rejected',
              allowedPermissions: ['see_all_sessions'],
              icon: MdOutlineAssignmentLate,
            },
            {
              title: 'externally_invalidated',
              href: `/session-management/externally-invalidated`,
              allowedRoles: ['administrator', 'operator', 'partition_agent'],
              icon: MdOutlineDangerous,
            },
            {
              title: 'rejected',
              href: '/session-management/rejected',
              allowedRoles: ['administrator', 'operator', 'partition_agent'],
              icon: MdOutlineDangerous,
            },
            {
              title: 'completed',
              href: '/session-management/completed',
              allowedRoles: ['administrator', 'operator', 'partition_agent'],
              notAllowedPermissions: ['hide_completed_sessions'],
              icon: MdOutlineAssignmentTurnedIn,
            },
          ].filter((item) => !item.canSkip),
        },
        {
          title: i18n.t('client reports'),
          icon: FaFileExport,
          allowedRoles: ['administrator'],
          children: [
            {
              title: i18n.t('yearly reports'),
              icon: FaFileExport,
              allowedRoles: ['administrator'],
              href: '/yearly-reports',
            },
            {
              title: i18n.t('billing reports'),
              icon: FaFileExport,
              allowedRoles: ['administrator'],
              href: '/billing-reports',
            },
          ],
        },
        {
          allowedRoles: ['administrator'],
          title: i18n.t('status'),
          href: '/status',
          icon: HiOutlineStatusOnline,
        },
        {
          allowedRoles: ['administrator'],
          title: i18n.t('troubleshooting'),
          href: '/troubleshooting',
          icon: MdSettings,
          children: [
            {
              allowedRoles: ['administrator'],
              title: i18n.t('workflow_logs'),
              href: '/troubleshooting/workflow_logs',
              icon: FaLayerGroup,
            },
            {
              allowedRoles: ['administrator'],
              title: i18n.t('logs24'),
              href: '/troubleshooting/events',
              icon: FaLayerGroup,
            },
            {
              allowedRoles: ['administrator'],
              title: i18n.t('sessions'),
              href: '/troubleshooting/sessions',
              icon: MdOutlineAssignmentInd,
            },

            ...(config.BETA === 'alpha'
              ? [
                  {
                    allowedRoles: ['administrator'],
                    title: i18n.t('workflow_compare'),
                    href: '/troubleshooting/compare-workflows',
                    icon: BiGitCompare,
                  },
                ]
              : []),
          ],
        },
      ],
    },
  ];
};
